import React, { Fragment } from 'react';
import BackButton from '../../../components/Common/BackButton';

interface OnboardingSuccessProps {
  submit: () => void;
  skip?: () => void;
  onBack: () => void;
}

const OnboardingSkipFinalOnboarding: React.FC<OnboardingSuccessProps> = ({ submit, skip, onBack }) => {
  const phoneNumber = '+1 805-697-1774';

  return (
    <>
      <div className="bg-white max-w-lg font-sofiaSans px-4 sm:px-0">
        <div className="text-start">
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-black mb-4 sm:mb-5">
            <span className="mr-1">✨</span>You’re ready for the next steps
          </h2>
          <div className="mt-2">
            <p className="text-sm text-secondaryStoryBlackText leading-relaxed">
              You’ve got things started. Your Next Steps will show you what’s ahead so your students can get started
              smoothly. Or, if you’d like, you can just poke around and take a look at the portal.
            </p>
          </div>
          <div className="mt-2">
            <p className="text-sm text-secondaryStoryGrayDescriptionText leading-relaxed mb-3">
              Need help? Call or text us anytime at {phoneNumber}
            </p>
          </div>
        </div>
      </div>
      <div className="w-full bg-white py-2 flex flex-row justify-between items-center gap-2 sm:gap-0 px-4 sm:px-0">
        <div>
          <BackButton onClick={onBack}></BackButton>
        </div>
        <div className="flex justify-end">
          <button
            className={`px-6 py-2 h-9 bg-secondaryStoryAdditionalLightBlueText text-whiteText font-bold leading-none rounded-2xl hover:shadow-md transition-shadow flex items-center justify-center text-sm sm:text-base w-auto`}
            onClick={() => submit()}
          >
            Finish
          </button>
        </div>
      </div>
    </>
  );
};

export default OnboardingSkipFinalOnboarding;
